import { Helmet } from "react-helmet";

import { AppConfig } from "../services/app-config-service";

interface MetaProps {
  title: string;
  description?: string;
}

const Meta = ({ title, description }: MetaProps) => {
  return (
    <Helmet>
      <title>
        {AppConfig.brandConfig.branding.fullName} {title ? `| ${title}` : ""}
      </title>
      {description && <meta name="description" content={description} />}

      <meta name="application-name" content={AppConfig.brandConfig.branding.fullName} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content={AppConfig.brandConfig.branding.fullName} />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content={AppConfig.brandConfig.meta.themeColor} />
    </Helmet>
  );
};

export default Meta;
